import React, { useEffect, useState } from "react";
import { Box, Paper, Fade } from "@mui/material";
import { useLocation } from "react-router-dom";

import LoginForm from "../components/auth/LoginForm";
import RegisterForm from "../components/auth/RegisterForm";
import ForgotPasswordForm from "../components/auth/ForgotPasswordForm";

export default function AuthPage() {
    const location = useLocation();
    const [mode, setMode] = useState("login");

    useEffect(() => {
        if (location.state?.mode === "forgot") {
            setMode("forgot");
        }
    }, [location.state]);

    return (
        <Box
            sx={{
                width: "100%",
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "var(--backgroundPage)",
                p: 2,
            }}
        >
            <Paper
                elevation={6}
                sx={{
                    width: "100%",
                    maxWidth: 420,
                    p: 4,
                    borderRadius: "22px",
                    textAlign: "center",
                    background: "var(--branco)",
                }}
            >
                <Fade in={mode === "login"} unmountOnExit>
                    <Box>
                        <LoginForm
                            onSwitch={() => setMode("register")}
                            onForgotPassword={() => setMode("forgot")}
                            passwordResetSuccess={location.state?.passwordResetSuccess}
                        />
                    </Box>
                </Fade>

                <Fade in={mode === "register"} unmountOnExit>
                    <Box>
                        <RegisterForm onSwitch={() => setMode("login")} />
                    </Box>
                </Fade>

                <Fade in={mode === "forgot"} unmountOnExit>
                    <Box>
                        <ForgotPasswordForm onBack={() => setMode("login")} />
                    </Box>
                </Fade>
            </Paper>
        </Box>
    );
}
